import * as config from '../../../../config.json';

export class GlobalConfig {
  public static readonly API_HOST = config.api.host;
  public static readonly API_URL = GlobalConfig.API_HOST + '/operations';
  public static readonly AUTH_URL = GlobalConfig.API_HOST + '/auth';
  public static ADD_API_URL = (url: string) => (GlobalConfig.API_URL +  url);
  public static ADD_AUTH_URL = (url: string) => (GlobalConfig.AUTH_URL +  url);
}
